import React from "react";
import useEventStore from "./store/eventStore";
import { Coins } from "../../assets/svg";
import { CiLocationOn } from "react-icons/ci";
import { IoCallOutline } from "react-icons/io5";
import { MdOutlineMailOutline } from "react-icons/md";
import { useParams } from "react-router-dom";
import {
  useEventDetails,
  useEventJoinedTeams,
} from "../../api/event/queryHooks";
import { decodeId, get_media_url } from "../../api/utils";
import {
  DocFileReference,
  ImageFileRefernce,
} from "../Athleteprofile/cards/referncefilecards";
import { getAppFunctionForStaticButtons } from "../../components/topbanner";

const Leaderboard = () => {
  return (
    <div className="text-left text-[#666666] text-sm font-semibold px-5">
      Coming soon!
    </div>
  );
};

const Schedule = () => {
  return (
    <div className="text-left text-[#666666] text-sm font-semibold px-5">
      Coming soon!
    </div>
  );
};

const Participation = () => {
  const id = decodeId(useParams()?.id);
  const { data, isLoading, isError } = useEventJoinedTeams(id, 1, 50);
  if (isError)
    return (
      <div className="text-left text-[#666666] text-sm font-semibold px-5">
        Something went wrong. Please try again later.
      </div>
    );

  return (
    <div className="grid grid-cols-2 md:grid-cols-8 gap-[15px] px-5">
      {/* <div className="grid grid-cols-2 md:grid-cols-8 md:px-0 gap-[15px] px-5"> */}
      {isLoading ? (
        Array.from({ length: 24 }).map((item, index) => (
          <div
            key={index}
            className="rounded-lg gap-5 aspect-[8/7] skeleton p-2"
          ></div>
        ))
      ) : data?.data?.data?.length ? (
        data.data.data.map((team) => (
          <div
            key={team.team_id}
            className="bg-[#333333] rounded-lg flex items-center justify-center flex-col gap-5 aspect-[8/7] p-2"
          >
            <img
              className="w-[50px] h-[50px] border rounded-full"
              src={get_media_url(team.team_dp)}
              alt="participation"
            />
            <p
              className="text-sm truncate w-full text-center cursor-pointer"
              title={team.team_name}
            >
              {team.team_name}
            </p>
          </div>
        ))
      ) : (
        <div className="text-left text-[#666666] text-sm font-semibold col-span-6">
          This event has no participation yet. Keep following for updates—they
          might share something exciting soon!
        </div>
      )}
    </div>
  );
};

const Overview = () => {
  const id = decodeId(useParams()?.id);
  const { data, isLoading } = useEventDetails(id);

  if (isLoading) return;

  return (
    <div className="px-5">
      <div className="grid grid-cols-1 gap-3 lg:grid-cols-3">
        <div className="flex items-center justify-between px-5 py-5 rounded-xl bg-[#2C2D36]">
          <div>
            <h3 className="text-[13px] lg:text-base">Entry Fee</h3>
            <div className="flex items-center gap-2">
              <Coins />
              <p>
                <span className="text-sm lg:text-lg">
                  {data.data?.entry_fee}
                </span>
                <span className="text-[10px] lg:text-xs"> Strikoin</span>
              </p>
            </div>
          </div>
          <div className="flex justify-center flex-col gap-2">
            <button
              onClick={getAppFunctionForStaticButtons}
              className="text-sm bg-gradient-to-r from-pinkish to-purpleish max-w-fit px-5 py-1 rounded-2xl lg:text-base"
            >
              Join
            </button>
            {/* <p className="text-[#AAAAAA] text-[9px]">Only 3 spots left</p> */}
          </div>
        </div>

        <div className="rounded-xl bg-[#2C2D36] px-5 py-5">
          <div>
            <p className="text-[13px]">Organised By</p>
          </div>
          <div className="py-3 flex items-center gap-3 border-b border-[#444444]">
            <div>
              <img
                className="w-10 h-10 rounded-full border"
                src={get_media_url(data.data.organised_by.profile_pc)}
                alt="orgainserimage"
              />
            </div>
            <div>
              <h3 className="text-sm">{data.data.organised_by.name}</h3>
              <p className="text-[10px]">
                Sponsored by / {data.data.organised_by.sponsored_by}
              </p>
            </div>
          </div>
          <div className="text-[#AAAAAA] text-[11px] mt-3">
            <p className="flex items-center gap-2">
              <span>
                <IoCallOutline />
              </span>
              <span>{data.data.organised_by.phone}</span>
            </p>
            <p className="flex items-center gap-2">
              <span>
                <MdOutlineMailOutline />
              </span>
              <span>{data.data.organised_by.email}</span>
            </p>
          </div>
        </div>

        <div className="rounded-xl bg-[#2C2D36]">
          <div className="flex justify-between items-center px-5 pt-3">
            <p className="text-[13px]">Location</p>
            <p className="text-[#0981FD] text-[11px]">Get Direction</p>
          </div>
          <div className="flex items-start gap-1 mt-2 px-5">
            <CiLocationOn className="flex-shrink-0" />
            <span className="text-xs text-[#AAAAAA] text-left">
              {data.data.address}, {data.data.city}, {data.data.country}
            </span>
          </div>
          <img
            src="https://static1.anpoimages.com/wordpress/wp-content/uploads/2022/07/googleMapsTricksHero.jpg"
            alt="map"
            className="w-full max-h-[120px] object-cover rounded-b-xl mt-3"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 gap-3 lg:grid-cols-2 my-3">
        <div className="rounded-xl bg-[#2C2D36] px-5 py-5">
          <div>
            <p className="text-[13px]">Description</p>
          </div>
          <div className="text-[11px] text-[#AAAAAA] mt-2">
            <p>{data.data.description}</p>
          </div>
        </div>

        <div className="rounded-xl bg-[#2C2D36] px-5 py-5">
          <div>
            <p className="text-[13px]">References</p>
          </div>
          <div className="py-3 flex items-start justify-center gap-4 border-b border-[#444444] flex-wrap">
            {data.data?.reference?.map((item, index) => {
              if (item.type === "doc")
                return <DocFileReference key={index} title={item.filename} />;
              else if (item.type === "image")
                return <ImageFileRefernce key={index} title={item.filename} />;

              return null;
            })}
          </div>
          <div className="text-[#F80B7B] text-[11px] mt-3">
            <a href="/">{data.data.organised_by.email}</a>
          </div>
        </div>
      </div>
    </div>
  );
};

const ContentContainerTab = () => {
  const selectedOption = useEventStore((state) => state.currentContentTab);

  if (selectedOption === null) return null;

  const Items = {
    1: Overview,
    2: Participation,
    3: Schedule,
    4: Leaderboard,
  };

  const Item = Items?.[selectedOption.id];
  if (Item) return <Item />;
};

export default ContentContainerTab;
